import { cm } from 'src/utils/classNames';
import { RadioGroupSize } from 'src/components/primitives/RadioGroup/types';
import { WithClassName } from 'src/utils/UtilityTypes';

interface GetRadioItemCardClassNameParams extends WithClassName {
	size: RadioGroupSize;
	disabled?: boolean;
}

export function getRadioItemCardClassName({
	size,
	disabled,
	className,
}: GetRadioItemCardClassNameParams) {
	const sizeClassName = {
		sm: 'py-xs typo-t4',
		md: 'py-sm typo-t4',
		lg: 'py-md typo-t3',
	}[size];

	return cm(
		'flex items-center justify-center px-md',
		'rounded-sm border border-stroke-divider bg-button-disabled',
		disabled && 'cursor-not-allowed text-text-disabled',
		!disabled && [
			'text-text-secondary',
			'hover:bg-purple-bg hover:text-text-default',
			'data-[state=checked]:border-button-primary-bg-hover data-[state=checked]:bg-button-selector data-[state=checked]:text-text-default',
		],
		sizeClassName,
		className
	);
}
